import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from '../helpers/emblaControls';
import ClassNames from 'embla-carousel-class-names';
const product = () => {
    const selectors = {
        mainProductSection: '[data-main-product]',
        productID: 'data-product-id',
        productHandle: 'data-product-handle',
        productInfo: '[data-product-info]',
        productForm: 'product-form',
        productImageContainer: '[data-product-image]',
        productDefaultImage: '[data-default-image]',
        currentVariant: 'data-variant-id',
        staticATC: '[data-static-add-to-cart]',
        stickyATC: '[data-sticky-add-to-cart]',
        pseudoVariantsCarousel: '[data-pseudo-variants-carousel]',
        pseudoVariantsCarouselViewport: '[data-pseudo-variants-carousel-viewport]',
        swatchCarousel: '[data-variant-swatches-carousel]',
        swatchCarouselViewport: '[data-variant-swatches-carousel-viewport]',
        swatchCarouselPrev: '[data-variant-swatches-carousel-prev]',
        swatchCarouselNext: '[data-variant-swatches-carousel-next]',
        swatchCarouselSlide: '.embla__slide',
        productAccordionBlock: '[data-product-accordion-block]',
        accordionTitle: '[data-accordion-title]',
        accordionContent: '[data-accordion-content]',
        openOnLoad: 'open-on-load',
        footer: 'footer',
    };
    const classes = {
        showStickyATC: 'sticky-add-to-cart--show',
        accordionOpen: 'product__accordion--open',
        hoverLeft: 'embla--hover-left',
        hoverRight: 'embla--hover-right',
    };
    const mainProductSections = document.querySelectorAll(selectors.mainProductSection);
    mainProductSections.forEach((section) => {
        const productInfo = section.querySelector(selectors.productInfo);
        const productImageContainer = section.querySelector(selectors.productImageContainer);
        const productDefaultImages = section.querySelectorAll(selectors.productDefaultImage);
        // Pseudo Variants Carousel
        const pseudoVariantsCarousel = section.querySelector(selectors.pseudoVariantsCarousel);
        if (pseudoVariantsCarousel) {
            const viewportNode = pseudoVariantsCarousel.querySelector(selectors.pseudoVariantsCarouselViewport);
            const options = {
                loop: false,
                align: 'start',
                skipSnaps: true,
            };
            const embla = EmblaCarousel(viewportNode, options);
        }
        // Add to Recently Viewed
        const productID = section.getAttribute(selectors.productID);
        const productHandle = section.getAttribute(selectors.productHandle);
        let viewedProducts = JSON.parse(sessionStorage.getItem('frank-green:recently-viewed-products'));
        if (!viewedProducts) {
            viewedProducts = [];
        }
        viewedProducts.push(productHandle);
        const uniqueViewedProducts = viewedProducts.filter((element, index) => {
            return viewedProducts.indexOf(element) === index;
        });
        sessionStorage.setItem('frank-green:recently-viewed-products', JSON.stringify(uniqueViewedProducts));
        // Sticky Add-to-Cart
        const staticATC = section.querySelector(selectors.staticATC);
        const stickyATC = section.querySelector(selectors.stickyATC);
        const footer = document.querySelector(selectors.footer);
        if (staticATC) {
            window.addEventListener('scroll', () => {
                const productFormTop = staticATC.getBoundingClientRect().top;
                const footerTop = footer.getBoundingClientRect().top;
                if (productFormTop < -50) {
                    stickyATC.classList.add(classes.showStickyATC);
                }
                else {
                    stickyATC.classList.remove(classes.showStickyATC);
                }
                if (footerTop < window.innerHeight) {
                    stickyATC.classList.remove(classes.showStickyATC);
                }
            });
        }
        if (stickyATC) {
            stickyATC.addEventListener('click', () => {
                staticATC.querySelector('.product-form__buttons button').click();
            });
        }
        // Images
        window.addEventListener('frank-green:variant-change', (event) => {
            if (event.detail.variantID) {
                section.setAttribute(selectors.currentVariant, event.detail.variantID);
                const variantImage = productImageContainer.querySelector('[data-variant-id="' + event.detail.variantID + '"]');
                if (variantImage) {
                    productDefaultImages.forEach((image) => {
                        image.style.setProperty('display', 'none');
                    });
                }
                else {
                    productDefaultImages.forEach((image) => {
                        image.style.setProperty('display', 'block');
                    });
                }
            }
        });
        // Swatches
        const swatchCarousels = document.querySelectorAll(selectors.swatchCarousel);
        if (swatchCarousels) {
            swatchCarousels.forEach((carousel) => {
                const viewportNode = carousel.querySelector(selectors.swatchCarouselViewport);
                const prevButtonNode = carousel.querySelector(selectors.swatchCarouselPrev);
                const nextButtonNode = carousel.querySelector(selectors.swatchCarouselNext);
                const options = {
                    loop: false,
                    align: 'start',
                    skipSnaps: true,
                };
                const embla = EmblaCarousel(viewportNode, options, [ClassNames()]);
                const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(embla, prevButtonNode, nextButtonNode);
                const slides = carousel.querySelectorAll(selectors.swatchCarouselSlide);
                slides.forEach((slide) => {
                    slide.addEventListener('click', () => {
                        const disabledInput = slide.querySelector('input.disabled');
                        if (disabledInput) {
                            //
                        }
                        else {
                            slide.querySelector('input').click();
                        }
                    });
                });
                // Hide / Show Arrows based on Cursor Position
                let viewportNodeHalfWidth = viewportNode.offsetWidth / 2, viewportNodeBounding = viewportNode.getBoundingClientRect(), viewportLeft = viewportNodeBounding.left, viewportRight = viewportNodeBounding.right;
                window.addEventListener('resize', () => {
                    viewportNodeHalfWidth = viewportNode.offsetWidth / 2;
                    viewportNodeBounding = viewportNode.getBoundingClientRect();
                    viewportLeft = viewportNodeBounding.left;
                    viewportRight = viewportNodeBounding.right;
                });
                viewportNode.addEventListener('mousemove', (e) => {
                    carousel.classList.remove(classes.hoverRight);
                    carousel.classList.remove(classes.hoverLeft);
                    if (e.clientX > viewportLeft && e.clientX < viewportLeft + viewportNodeHalfWidth) {
                        carousel.classList.add(classes.hoverLeft);
                    }
                    if (e.clientX > viewportLeft + viewportNodeHalfWidth && e.clientX < viewportRight) {
                        carousel.classList.add(classes.hoverRight);
                    }
                });
                viewportNode.addEventListener('mouseleave', () => {
                    carousel.classList.remove(classes.hoverLeft);
                    carousel.classList.remove(classes.hoverRight);
                });
            });
        }
        // Accordions
        const openAccordion = (accordion) => {
            const content = accordion.querySelector(selectors.accordionContent);
            accordion.classList.add(classes.accordionOpen);
            content.style.maxHeight = content.scrollHeight + 'px';
        };
        const closeAccordion = (accordion) => {
            const content = accordion.querySelector(selectors.accordionContent);
            accordion.classList.remove(classes.accordionOpen);
            content.style.maxHeight = null;
        };
        const productAccordionBlocks = productInfo.querySelectorAll(selectors.productAccordionBlock);
        productAccordionBlocks.forEach((accordion) => {
            const title = accordion.querySelector(selectors.accordionTitle);
            const content = accordion.querySelector(selectors.accordionContent);
            if (content.hasAttribute(selectors.openOnLoad)) {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
            if (title && content) {
                title.onclick = () => {
                    if (content.style.maxHeight) {
                        closeAccordion(accordion);
                        accordion.classList.remove(classes.accordionOpen);
                    }
                    else {
                        productAccordionBlocks.forEach((accordion) => closeAccordion(accordion));
                        openAccordion(accordion);
                        accordion.classList.add(classes.accordionOpen);
                        setTimeout(() => {
                            const rect = title.getBoundingClientRect();
                            const inView = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
                            const scrollOffset = 100;
                            const scrollPosition = window.scrollY + rect.top - scrollOffset;
                            if (!inView) {
                                window.scrollTo({
                                    top: scrollPosition,
                                    behavior: 'auto',
                                });
                            }
                        }, 500);
                    }
                };
            }
        });
        window.addEventListener('resize', () => {
            productAccordionBlocks.forEach((accordion) => {
                const content = accordion.querySelector(selectors.accordionContent);
                if (content && content.style.maxHeight) {
                    openAccordion(accordion);
                }
            });
        });
    });
};
export { product };
